import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  makeStyles,
  CssBaseline,
  Grid,
  Paper,
  Typography,
  Box,
  Button,
  Snackbar,
  CircularProgress,
} from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import QuestionPage from "./QuestionPage";
import ConfirmationDialog from "../../Common/Confirmation";
import { useHistory } from "react-router-dom";
import DurationComponent from "./durationComponent";
import axios from "axios";
import { Beforeunload } from "react-beforeunload";
import { Offline } from "react-detect-offline";
import Alert from "@material-ui/lab/Alert";
import networkSyncService from "../../../services/NetworkSyncService";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1.2%",
    position: "relative",
    height: "80vh",
  },
  paperContainer: {
    padding: theme.spacing(1.5),
  },
  cardHeader: {
    backgroundColor: "tomato",
    textAlign: "center",
  },
  buttonOption: {
    width: "100%",
    padding: theme.spacing(1),
    border: 0,
  },
  title: {
    fontSize: 30,
    backgroundColor: "#ff4154",
    borderCollapse: "collapse",
    width: "100%",
    borderSpacing: 10,
    borderTop: 0,
    textAlign: "center",
    color: "white",
    fontWeight: "bold",
  },
  question: {
    fontWeight: "bold",
    color: "#000099",
    fontSize: "40px",
  },
  cardContainer: {
    borderRadius: "30px",
  },
  questionContainer: {
    whiteSpace: "pre-line",
    fontSize: "30px",
    fontWeight: "500",
    alignItems: "space-between",
    textAlign: "right",
  },
  icon: {
    backgroundColor: "#ff4154",
  },
  paper: {
    padding: theme.spacing(2),
    color: "white",
    backgroundColor: "#ff4154",
    borderCollapse: "collapse",
    fontSize: 12,
    fontWeight: "bold",
    borderRadius: 15,
    justifyContent: "center",
    width: "95%",
    display: "inline-block",
    height: "auto",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

function Exam2(props) {
  const classes = useStyles();
  const history = useHistory();
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const BASE_URL = `${process.env.REACT_APP_API_URL}`;
  const [answers, setAnswers] = React.useState([]);
  const [answeredQuestion, setAnsweredQuestion] = React.useState(0);
  const [examObject] = React.useState(props.location.state.examObject);
  const [examinationType] = React.useState(props.location.state.examinationType);
  
  const [allotedTime,setAllotedTime] = React.useState();
  
  const [stopTimer, setStopTimer] = React.useState(false);
  const [syncTimer,setSyncTimer] = React.useState(false);
  const timeToWaitForExamAbortionInSec = 300;
  const [totalNoOfQueInPreSec, setTotalNoOfQueInPreSec] = useState(0);
  const [networkDownCountDown, setNetworkDownCountDown] = React.useState(
    timeToWaitForExamAbortionInSec
  );
  const [isOffline, setIsOffline] = React.useState(!navigator.onLine);
  const [totalNoOfQuestions, setTotalNoOfQuestions] = React.useState(0);
  const [pendingAnswersCount, setPendingAnswersCount] = React.useState(0);
  const [examRestored, setExamRestored] = React.useState(false);
  const polling = {
    enabled: false,
    interval: 20000,
    timeout: 20000,
    
  };
  const [agcTimeLoad,setAGCTimeLoad] = React.useState(false)
  const [questionPaper, setQuestionPaper] = React.useState([]);
  const [tabDisability,setTabDisability] = React.useState(false);
  const [totalTimeSync,setTotalTimeSync] = React.useState(false);
  let retryCount=0; 
  useEffect(() => {
    if(syncTimer){
    const duration = props.location.state.examObject.exam.duration
    .toString()
    .split(":");
  
  // Use server-authoritative start time if available
  const durationInTime = examObject.startTime ? new Date(examObject.startTime) : new Date();
  
  const totalHrs = durationInTime.getHours() + parseInt(duration[0]);
  const totalMins = durationInTime.getMinutes() + parseInt(duration[1]);
  durationInTime.setHours(totalHrs, totalMins);
  setAllotedTime(durationInTime);
  
}
},[syncTimer, examObject.startTime])

  function replaceBrowserHistory() {
    history.replace("/student/portal/dashboard",{examination:examObject.examination});
  }

  const syncOfflineAnswers = async () => {
    try {
      const pendingAnswers = await networkSyncService.getPendingAnswers();
      if (pendingAnswers.length > 0) {
        setPendingAnswersCount(pendingAnswers.length);
        
        // Let's submit the pending answers
        await axios.post(BASE_URL + `/answers`, pendingAnswers, {
          headers: { authorization: "Bearer " + localStorage.getItem("authorization") },
        });
        await networkSyncService.clearPendingAnswers();
        setPendingAnswersCount(0);
      }
    } catch (e) {
      console.error("Error syncing offline answers", e);
    }
  };

  const syncSingleAnswer = async (answer) => {
    if (isOffline) {
      await networkSyncService.queueAnswer(answer);
    } else {
      try {
        await axios.post(BASE_URL + `/answers`, [answer], {
          headers: { authorization: "Bearer " + localStorage.getItem("authorization") },
        });
      } catch (error) {
        await networkSyncService.queueAnswer(answer);
      }
    }
  };

  useEffect(() => {
    if (!isOffline) {
      syncOfflineAnswers();
    }
  }, [isOffline]);

  useEffect(() => {
    // Save state on every answers or tabValue change
    if (examRestored && examObject && examObject.exam) {
      networkSyncService.saveExamState(examObject.exam.examId, {
        answers,
        tabValue: value,
        startTime: examObject.startTime
      });
    }
  }, [answers, value, examRestored, examObject.startTime]);

  useEffect(() => {
    if (stopTimer) {
      handleSubmit();
    } else {

      axios
        .get(BASE_URL + `/batches/${examObject.exam.examId}/questionPaper`, {
          headers: {
            authorization: "Bearer " + localStorage.getItem("authorization"),
          },
        })
        .then(async (response) => {       
          // setTimeout(() => {
            
                // Restore state from local IndexedDB if available
                const savedState = await networkSyncService.getExamState(examObject.exam.examId);
                if (savedState) {
                  if (savedState.answers) setAnswers(savedState.answers);
                  if (savedState.tabValue) setValue(savedState.tabValue);
                  if (savedState.startTime && !examObject.startTime) {
                    examObject.startTime = savedState.startTime;
                  }
                }
                setExamRestored(true);

                setQuestionPaper(response.data);
                if (!examObject.isMokeTest || examObject.exam.recordPracticeScores) {
                  updateExamParticipation("in-progress");
                }
                countQuestions(response.data.modules);
                disableBatch();
                if (examinationType !=='prodigy'){
                  setAGCTimeLoad(true);
                } 
              // }, 6000);  
                    
        });
    }
    if(examinationType ==='prodigy'){
      setTabDisability(true);
    }
  }, [examObject.exam.examId, stopTimer]);

  const [offlineStartTime, setOfflineStartTime] = React.useState(null);

  React.useEffect(() => {
    // Network reconnect sync is handled in the other useEffect
    // We remove the automatic exam abortion countdown while offline.
  }, [isOffline]);

  const countQuestions = (event) => {
    let questions = 0;
    for (var i = 0; i < event.length; i++) {
      questions = questions + Number([event[i].questionBank.length]);
      setTotalNoOfQuestions(questions);
    }
  };

   const  handleSubmit = async() => {
    if (!examObject.isMokeTest || examObject.exam.recordPracticeScores) {
    if(retryCount<10){
     await axios
        .post(BASE_URL + `/answers`, answers, {
          headers: {
            authorization: "Bearer " + localStorage.getItem("authorization"),
          },
        })
        .then((response) => {  
          updateExamParticipation("completed");
          disableBatch();
          // to navigate to dashboard instead of exam page when clicking on browser back button
          replaceBrowserHistory();
          history.push({
            pathname: '/agc/thankYou',
            state: { message: 'Thank You for taking the test...', status: true,examination:examObject.examination }
        });
        }).catch(function (error){ 
            retryCount++;
            //wait for 10 sec
            setTimeout(function(){ 
                handleSubmit();
            }, 10000);
        });
}else{
    const errorMessage ="Unable to save results due to internet connection interruption. Please take the test again or contact your SIP Abacus Center for scheduling a retest. Thank you."
    updateExamParticipation("aborted");
    replaceBrowserHistory();
    history.push({
      pathname: "/agc/thankYou",
      state: { message: errorMessage, status: false, examination:examObject.examination },
    });
}
    }else{
      disableBatch();  
        // to navigate to dashboard instead of exam page when clicking on browser back button 
        replaceBrowserHistory();
        history.push(
            {
                pathname: '/agc/thankYou',
                state: { message: 'Thank You for taking the test...', status: true,examination:examObject.examination }
            });

    }
  };

  const handleTabChange = async (event, newValue) => {
    setValue(newValue);
    let totalNoOfQuePresent = 0;
    for (let index = 0; index < newValue; index++) {
      totalNoOfQuePresent =
        totalNoOfQuePresent + questionPaper.modules[index].questionBank.length;
    }
    await setTotalNoOfQueInPreSec(totalNoOfQuePresent);
  };

  const handleClose = (confirmed) => {
    setOpen(false);
    if (confirmed) {
      handleSubmit();
    }
  };

  const updateExamParticipation = (status) => {
    let examParticipationObject = [];
    if (status === "in-progress") {
      examParticipationObject = {
        studentBatchSchedule: {
          studentBatchScheduleId: examObject.studentBatchScheduleId,
        },
        examStatus: status,
        examParticipationId: examObject.examParticipationId,
      };
    } else {
      examParticipationObject = {
        studentBatchSchedule: {
          studentBatchScheduleId: examObject.studentBatchScheduleId,
        },
        examStatus: status,
        examParticipationId: examObject.examParticipationId,
        questionPaper: {
          questionPaperId: questionPaper && questionPaper.questionPaperId,
        },
      };
    }

    saveOrUpdateExamStatus(examParticipationObject);
  };

  function saveOrUpdateExamStatus(examParticipationObject) {
    axios
      .post(BASE_URL + `/examParticipation`, examParticipationObject, {
        headers: {
          authorization: "Bearer " + localStorage.getItem("authorization"),
        },
      })
      .then((response) => {});
  }

  const disableBatch = () => {
    let studentBatchScheduleObject = {
      studentBatchScheduleId: examObject.studentBatchScheduleId,
      batch: {
        batchId: examObject.batchId,
      },
      exam: {
        examId: examObject.exam.examId,
      },
      student: {
        studentId: examObject.studentId,
      },
      active: false,
    };

    axios
      .post(BASE_URL + `/student/batch`, studentBatchScheduleObject, {
        headers: {
          authorization: "Bearer " + localStorage.getItem("authorization"),
        },
      })
      .then((response) => {});
  };

  function reduceTime(timeLeft) {
    // Deprecated countdown function - kept for backwards compatibility if needed, but not used during offline
  }
  return (
    <Box>
      <Offline
        polling={polling}
        onChange={(online) => {
          const currentlyOffline = !online;
          if (currentlyOffline) {
            setOfflineStartTime(new Date().getTime());
          } else {
            if (offlineStartTime) {
              const offlineDuration = new Date().getTime() - offlineStartTime;
              const newAllotedTime = new Date(allotedTime.getTime() + offlineDuration);
              setAllotedTime(newAllotedTime);
              if (examObject.startTime) {
                examObject.startTime = new Date(new Date(examObject.startTime).getTime() + offlineDuration).toISOString();
              }
              setOfflineStartTime(null);
            }
          }
          setIsOffline(currentlyOffline);
        }}
      >
        {isOffline && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9999, display: 'flex', justifyContent: 'center' }}>
            <Alert severity="error" style={{ position: 'absolute', top: 0, width: '100%', justifyContent: 'center' }}>
              Internet Connection Lost! Reconnecting in 1 min...
            </Alert>
          </div>
        )}

        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={!isOffline && pendingAnswersCount > 0}
          key="top center sync"
        >
          <Alert severity="info">
            Connection Restored! Synchronizing {pendingAnswersCount} offline answers...
          </Alert>
        </Snackbar>
      </Offline>
      <Beforeunload
        onBeforeunload={(event) => {
          event.returnValue = "are sure, you want to close this page?";
          event.preventDefault();
        }}
      />
      <div className={classes.root}>
        <CssBaseline />
        <Grid
          container
          alignItems="center"
          justify="center"
          direction="row"
          className={classes.paperContainer}
        >
          <DurationComponent
            examObject={examObject}
            answeredQuestion={answeredQuestion}
            totalNoOfQuestions={totalNoOfQuestions}
            setStopTimer={setStopTimer}
            allotedTime={allotedTime}
            examinationType ={examinationType}
            setSyncTimer={setSyncTimer}
            syncTimer={syncTimer}
            agcTimeLoad={agcTimeLoad}
            totalTimeSync ={totalTimeSync}
            setTotalTimeSync={setTotalTimeSync}
            isOffline={isOffline}
            offlineStartTime={offlineStartTime}
          />
          <Grid item xs={12} md={12}>
            <Paper elevation={4} style={{ marginTop: "5px" }}>
              <Tabs
                value={value}
                onChange={handleTabChange}
                variant="fullWidth"
                indicatorColor="primary"
                aria-label="module tabs"
              >
                {questionPaper.modules &&
                  questionPaper.modules.map((module, index) => (
                    <Tab label={module.name} {...a11yProps(index)} disabled ={tabDisability} style={{fontWeight:'bold',color:'black'}} />
                  ))}
              </Tabs>
              {questionPaper.modules &&
                questionPaper.modules.map((module, index) => (
                  <TabPanel
                    value={value}
                    index={index}
                    style={{ marginTop: "-0.8%" }}
                  >
                  {/* {syncTimer &&( */}
                      <QuestionPage
                      questions={module.questionBank}
                      moduleDuration = {module.moduleDuration}
                      moduleName = {module.name}
                      answers={answers}
                      setAnswers={setAnswers}
                      examObject={examObject}
                      setAnsweredQuestion={setAnsweredQuestion}
                      totalNoOfQueInPreSec={
                        index === 0 ? 0 : totalNoOfQueInPreSec
                      }
                      setTabValue={setValue}
                      tabValue={value}
                      moduleLength={questionPaper.modules.length}
                      examinationType={examinationType}
                      setSyncTimer={setSyncTimer}
                      syncTimer={syncTimer}
                      totalTimeSync ={totalTimeSync}
                      setTotalTimeSync={setTotalTimeSync}
                      setStopTimer={setStopTimer}
                      isOffline={isOffline}
                      syncSingleAnswer={syncSingleAnswer}
                    />
                     {/* )}  */}

                  </TabPanel>
                ))}
                  {!syncTimer ? <CircularProgress size={60} style={{ marginLeft: '50%', position: 'relative', top: 4 }} /> :null }
            </Paper>
          </Grid>
          <Grid item xs={12} md={12}>
            <Paper
              style={{ padding: "10px", marginTop: "-1.3%", justify: "center" }}
            >
              <Grid
                item
                container
                alignItems="center"
                justify="center"
                xs={12}
                md={12}
              >
                <ConfirmationDialog
                  onClose={handleClose}
                  message={"Are You sure?, You want to submit?"}
                  open={open}
                />
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
}

export default Exam2;
